import styled from 'styled-components'
import { breakpoint, fontSize, spacing } from '../theme'

export const Table = styled.div`
   display: block;
   width: 100%;
   font-size: ${fontSize.s};
   @media screen and (min-width: ${breakpoint.s}) {
      font-size: ${fontSize.sm};
   }
`

export const TableHeader = styled.div`
   display: -ms-inline-flexbox;
   display: grid;
   width: 100%;
   grid-template-columns: 2fr repeat(2, 1fr);
   font-weight: bold;
   margin: ${spacing.s} 0;
`

export const TableRowTitle = styled.div`
   display: -ms-inline-flexbox;
   display: grid;
   width: 100%;
   grid-template-columns: 1fr;
   font-weight: bold;
`

export const TableRow = styled.div`
   display: -ms-inline-flexbox;
   display: grid;
   width: 100%;
   grid-template-columns: 2fr repeat(2, 1fr);
`
